import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { SoftwarelistService } from "src/app/_services/softwarelist/softwarelist.service";
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-softwarelist',
  templateUrl: './softwarelist.component.html',
  styleUrls: ['./softwarelist.component.scss']
})
export class SoftwarelistComponent implements OnInit {
  softwarelistForm
   // row data and column definitions  
   rowData: any;
   public columnDefs: ColDef[]; 
   modeAction:number = 1 //1 - create // 2 - update
   // gridApi and columnApi  
   private api: GridApi;  
   private columnApi: ColumnApi;  
    defaultColDef:any;
    rowSelection:any
    tenantId: string;
    userDetails: any;
    form: FormGroup;
    selectedRow: any;
    selectedFile: File;
    modalService: any;
    currentUser: any;
    jsonData: any;
    emailPattern = "^[a-z0-9._%+-]+\\.[a-z]{2,4}$";
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = []
    deleteConfirmationMsg = 'Are you sure you want to delete'
  slattachment: Object;
  imageid: any;
  url: string;
  constructor(
    private storageService: LocalStorageService,
    private softwarelistService: SoftwarelistService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
     private router: Router
  ) { 
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
      this.columnDefs = this.createColumnDefs();  
  
      this.sampleGridFrameworkComponents = {
        actionRowRendererComponent: ActionItemsGridRowRendererComponent
      };
  
      this.form = this.formBuilder.group({
        file: ['', Validators.required]
      });

      this.softwarelistForm= this.formBuilder.group({
        id: new FormControl(''),
        softwareName: new FormControl('', Validators.required),
        licenseNo: new FormControl('', [ Validators.required, Validators.pattern('^[0-9 ]*$') ]),
        licenseExpiry: new FormControl('', Validators.required),
        licenseInstallation: new FormControl('', Validators.required),
        licenseRenewalEndDate: new FormControl('', Validators.required),
      })
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.getSoftware();

   // if (this.selectedCheckboxData[0].id) {
      //this.getUserSlApplicationDetailsById(this.leaveapprowId);
    //  this.getslApplicationsattachments(this.selectedCheckboxData[0].id);
   // }
  }

  getSoftware(){
    this.softwarelistService.getAllSoftwares().subscribe((response: any) => {
      this.rowData = response.result;
      console.log("response: ", response);
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  } 

   // create column definitions  
   private createColumnDefs() {
    return [
    {
      headerName: 'Software Name',
      field: 'softwareName',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'License No',
      field: 'licenseNo',
      filter: true,
      editable: false,
      sortable: true,
    },
    {
      headerName: 'License Expiry',
      field: 'licenseExpiry',
      filter: true,
      editable: false,
      sortable: true,
      
    },
    {
      headerName: 'License Installation',
      field: 'licenseInstallation',
      filter: true,
      editable: false,
      sortable: true,
      
    },
    {
      headerName: 'License Renewal End Date',
      field: 'licenseRenewalEndDate',
      filter: true,
      editable: false,
      sortable: true,
      
    },
    
  ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createSoftware(){
    let details = {
      softwareName: this.softwarelistForm.get('softwareName').value,
      licenseNo: this.softwarelistForm.get('licenseNo').value,
      licenseExpiry: this.softwarelistForm.get('licenseExpiry').value,
      licenseInstallation: this.softwarelistForm.get('licenseInstallation').value,
      licenseRenewalEndDate: this.softwarelistForm.get('licenseRenewalEndDate').value,
    }
    this.softwarelistService.createSoftwares(details).subscribe((response: any) => {
       console.log("response: ", response);

       // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
      
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.softwarelistService.deleteSoftwares(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.getslApplicationsattachments(this.selectedCheckboxData[0].id);
    this.softwarelistForm.patchValue(this.selectedCheckboxData[0])
  }

  createOpenModal() {
    this.modeAction = 1;
    this.softwarelistForm.reset();
    this.softwarelistForm.patchValue({
      id: '',
      softwareName: '',
      licenseNo: '',
      licenseExpiry: '',
      licenseInstallation: '',

    })
  }

  updateSoftware() {
    this.softwarelistService.updateSoftwares(this.softwarelistForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getSoftware();
      this.selectedCheckboxData = []
      $('#closeCreateModal').trigger("click");
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].softwareName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].softwareName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].softwareName}`;
    }
  }

  deleteTimesheetList() {
    this.softwarelistService.deleteSoftwares(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getSoftware();
      this.selectedCheckboxData = []
      $('#closeModalDeleteTimesheet').trigger("click");
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.softwarelistForm.controls;
  }

  //Gets called when the user selects an image
  public onFileChanged(event) {
    //Select File
    this.selectedFile = event.target.files[0];
    console.log('in onFileChanged, selectedFile: ', this.selectedFile);
    this.onUpload();
  }

  //Gets called when the user clicks on submit to upload the image
  onUpload() {
    console.log('in onUpload, selectedFile: ', this.selectedFile);
    console.log('in onUpload, selectedFile: ', this.selectedFile.name);

    // get logged in user's details
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    console.log("current user's id: ", this.currentUser.id);

    //FormData API provides methods and properties to allow us easily prepare form data to be sent with POST HTTP requests.
    const uploadImageData = new FormData();

    uploadImageData.append('file', this.selectedFile, this.selectedFile.name);
    console.log('uploadImageData: ', uploadImageData);

    //Make a call to the Spring Boot Application to save the image
    this.softwarelistService.uploadImage(
      Number(this.selectedCheckboxData[0].id),
      uploadImageData
    ).subscribe((response: any) => {
      console.log('upload image response: ', response);
      if (response) {
        // this.message = 'Image uploaded successfully';
        window.alert('Image uploaded successfully');
        window.location.reload();

      } else {
        // this.message = 'Image not uploaded successfully';
       // window.alert('Image upload NOT successfull');
       window.location.reload();

      }
    });

    setTimeout(() => {
      this.getslApplicationsattachments(this.selectedCheckboxData[0].id);
    }, 400);
  }

  getslApplicationsattachments(id) {
    //console.log('I AM IN GET getUserSlApplicationDetailsById ');

    this.softwarelistService.getslApplicationsattachments(id).subscribe(
      (response) => {
        console.log('getslApplicationsattachments: ', response);
        this.slattachment = response;
        console.log('getslApplicationsattachments: ', this.slattachment);
      },
      (error) => {
        //console.log('ERROR: cannot get project by id: ' + error);
      }
    );
  }

  deleteslApplicationsattachments(value) {
    console.log('I AM IN deleteslApplicationsattachments ', value);

    this.imageid = value.split(': ')[0];

    this.softwarelistService.deleteslApplicationsattachments(
      this.selectedCheckboxData[0].id,
      this.imageid
    ).subscribe(
      (response) => {
        console.log('deleteslApplicationsattachments: ', response);
        window.alert('Delete Successful');
       // window.location.reload();
       this.getslApplicationsattachments(this.selectedCheckboxData[0].id)
      },
      (error) => {
        //console.log('ERROR: cannot get project by id: ' + error);
      }
    );
  }

  downloadslApplicationsattachments(value) {
    console.log('I AM IN downloadslApplicationsattachments ', value);

    this.imageid = value.split(': ')[0];

    this.url = environment.apiUrl + '/softwares/' + this.selectedCheckboxData[0].id + '/attachments/' + this.imageid;
    console.log('downloadslApplicationsattachments url: ', this.url);

    const header = {
      headers: new HttpHeaders({
        'Authorization': this.storageService.get('token'),
        'tenantId': this.storageService.get('tenantId'),
      }),
    };

   // window.open(this.url, "_blank");

    
    this.softwarelistService.downloadslApplicationsattachments(
      this.selectedCheckboxData[0].id,
      this.imageid
    ).subscribe(
      (response) => {
       // console.log('downloadleaveApplicationsattachments: ', this.url);
       this.url = environment.apiUrl + '/softwares/' + this.selectedCheckboxData[0].id + '/attachments/' + this.imageid;
       //window.open(this.url, "_blank");

        window.alert('Download Successful');
        console.log('downloadslApplicationsattachments in ts: ', response);


        //window.location.reload();
       // this.retrievedImage = 'data:image/jpeg;base64,' + ;
       // console.log('this.retrievedImage downloadslApplicationsattachments: ', this.retrievedImage);

      },
      (error) => {
        //console.log('ERROR: cannot get project by id: ' + error);
      }
    );
    
  }


}
